import { Grid } from "@mui/material";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Data
import VendorAppplication from "./vendorAppplication";

function VendorApplication() {
  return (
    <Card sx={{ height: "fit-content", overflow: "auto" }}>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox p={2} mb={-2} mt={-2}>
              <MDTypography variant="h6" gutterBottom>
                Recent Supplier Applications
              </MDTypography>
            </MDBox>

            {/* Directly show Vendor Application */}
            <VendorAppplication />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default VendorApplication;
